import { AlphaDCircleOutlineIcon } from './AlphaDCircleOutlineIcon';

/**
 * author: Contributors
 * id 6B6C0FE9-544A-4098-A5B2-823160140EE7
 * name alpha-d-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-d-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterDCircleOutlineIcon = AlphaDCircleOutlineIcon;
export default LetterDCircleOutlineIcon